import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Icon, Card, Popconfirm, Popover } from 'antd';

export class HrCardDetail extends Component {
    static displayName = HrCardDetail.name;

    constructor(props) {
        super(props);

        this.state = {
            hr: this.props.hr,
            company: this.props.comp
        };
        this.deleteHr = this.deleteHr.bind(this);
    }

    deleteHr() {
        this.props.delete();
    }

    render() {

        let name = this.state.hr.name != null ? this.state.hr.name.charAt(0) : ''

        let surname = this.state.hr.surname != null ? this.state.hr.surname.charAt(0) : ''

        let iniziale = <div className="fakeImageHr">{name}{surname}</div>

        let immagine = this.state.hr.portraitImage ? <div className="hrPortrait" style={{ backgroundImage: 'url(' + `${'data:image/png;base64,' + this.state.hr.portraitImage}` + ')' }}></div> : <div>{iniziale}</div>;

        return (
            <Card actions={[<Link target="_blank" to={"/modifyhr?hrId=" + this.state.hr.hrId} ><Popover content="Edit"><Icon type="edit" /></Popover></Link>, this.state.hr.brHrRoleOfficies.length == 0 ? <Popconfirm title="Are you sure about permanently deleting this HR?" okText="Yes" cancelText="No" onConfirm={this.deleteHr} ><Popover content="Delete"><Icon type="close" className="blueIcon" /></Popover></Popconfirm> : <Popover content="This HR has a role, it can't be deleted"><Icon type="close" twoToneColor="gray" /></Popover >]}>
                {immagine}
                <h3 style={{ marginBottom: '0px', fontSize: '24px', marginTop: '10px' }}>{this.state.hr.fullName}</h3>

                <hr style={{ borderColor: "#000", marginTop: '20px' }} />

                <Container fluid={true}>
                    {this.state.hr.brHrRoleOfficies.map((br, i) => {
                        if (br.office.company != null) {
                            let immagineComp = br.office.company.companyImage !== null ? <div style={{ backgroundSize: 'cover', backgroundImage: 'url(' + `${'data:image/png;base64,' + br.office.company.companyImage}` + ')' }} className="compLogoDetail"></div> : <div className="compLogoDetail">{br.office.company.name.charAt(0)}</div>;
                            let spaziatura = i > 0 ? < hr style={{ marginTop: '20px' }} /> : ""
                            let title = br.title != null ? <p style={{ textAlign: 'left' }}><b>Title:</b> {br.title}</p> : ''

                            return (
                                <Row key={br.hroId}>
                                    <Col sm="12">
                                        {spaziatura}
                                    </Col>
                                    <Col sm="4">
                                        {immagineComp}
                                    </Col>
                                    <Col sm="8">
                                        <h6 style={{ marginBottom: '10px' }}><Link to={"/edit?id=" + br.office.company.companyId} >{br.office.company.name}</Link></h6>
                                        <p style={{ textAlign: 'left' }}><b>Role:</b> {br.role.name}</p>
                                        {title}
                                        <ul className="elencoContactHr">
                                            {br.brHrRoleOfficeContacts.map((con, i) => {
                                                if (con.contact.property_TrValue === 6 && con.contact.hroId === br.hroId) {
                                                    return (<div key={con.contact.contactId}><p><Icon type="home" /> {con.contact.text}</p></div>)
                                                }
                                                else if (con.contact.property_TrValue === 3 && con.contact.hroId === br.hroId) {
                                                    return (<div key={con.contact.contactId}><p><Icon type="phone" /> {con.contact.text}</p></div>)
                                                }
                                                else if (con.contact.property_TrValue === 7 && con.contact.hroId === br.hroId) {
                                                    return (<div key={con.contact.contactId}><p><Icon type="printer" /> {con.contact.text}</p></div>)
                                                }
                                                else if (con.contact.property_TrValue === 4 && con.contact.hroId === br.hroId) {
                                                    return (<div key={con.contact.contactId}><p><Icon type="global" /> {con.contact.text}</p></div>)
                                                }
                                                else if (con.contact.property_TrValue === 5 && con.contact.hroId === br.hroId) {
                                                    return (<div key={con.contact.contactId}><p><Icon type="mail" /> {con.contact.text}</p></div>)
                                                }
                                            })
                                            }
                                        </ul>
                                    </Col>
                                </Row>
                            )
                        } else {
                            let spaziatura = i > 0 ? < hr style={{ marginTop: '20px' }} /> : ""
                            return (
                                <Row key={br.hroId}>
                                    <Col sm="12">
                                        {spaziatura}
                                    </Col>
                                    <Col sm="4">
                                        <div className="compLogoDetail">{this.state.hr.name.charAt(0)}</div>
                                    </Col>
                                    <Col sm="8">
                                        <p style={{ textAlign: 'left' }}><b>Ruolo:</b> {br.title} {br.role.name}</p>
                                        <ul className="elencoContactHr">
                                            {br.brHrRoleOfficeContacts.map((con, i) => {
                                                if (con.contact.property_TrValue === 6 && con.contact.hroId === br.hroId) {
                                                    return (<div key={con.contact.contactId}><p><Icon type="home" /> {con.contact.text}</p></div>)
                                                }
                                                else if (con.contact.property_TrValue === 3 && con.contact.hroId === br.hroId) {
                                                    return (<div key={con.contact.contactId}><p><Icon type="phone" /> {con.contact.text}</p></div>)
                                                }
                                                else if (con.contact.property_TrValue === 7 && con.contact.hroId === br.hroId) {
                                                    return (<div key={con.contact.contactId}><p><Icon type="printer" /> {con.contact.text}</p></div>)
                                                }
                                                else if (con.contact.property_TrValue === 4 && con.contact.hroId === br.hroId) {
                                                    return (<div key={con.contact.contactId}><p><Icon type="global" /> {con.contact.text}</p></div>)
                                                }
                                                else if (con.contact.property_TrValue === 5 && con.contact.hroId === br.hroId) {
                                                    return (<div key={con.contact.contactId}><p><Icon type="mail" /> {con.contact.text}</p></div>)
                                                }
                                            })
                                            }
                                        </ul>
                                    </Col>
                                </Row>
                            )
                        }
                    })
                }
                </Container>
            </Card >
        )
    }
}


// WEBPACK FOOTER //
// ./src/Hr/HrCardDetail.js